import {
  useTheme,
  Stack,
  Box,
  Paper,
  Typography,
  LinearProgress,
  alpha,
  Skeleton,
  Button,
} from "@mui/material";
import { ptBR } from "@mui/x-data-grid/locales";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import useStyles from "../styles";
import { useOutletContext } from "react-router-dom";
import ResponsiveArea from "../../../componentes/easyLogs/nivoResponsiveArea";
import { useState } from "react";
import ModalERP from "../../../componentes/easyLogs/modalERPv2";

export const InsightsEasyLog = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [loading, setLoading] = useState(false);

  const {
    CustomNoRowsOverlay,
    loadingAloc,
    loadingVarPort,
    rowsAloc = [],
    portsTime = [],
    erpStatus = false,
  } = useOutletContext();
  const apiRefAloc = useGridApiRef();

  const columns = [
    { field: "id", headerName: "id", width: 90 },
    {
      field: "IP Privado",
      headerName: "IP Privado",
      width: 150,
      renderCell: (params) => {
        return erpStatus ? (
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              textDecoration: `underline ${theme.palette.text.primary}`,
              color: theme.palette.text.primary,
            }}
          >
            {params.value}
          </Typography>
        ) : (
          params.value
        );
      },
    },
    {
      field: "Recorrência",
      headerName: "Recorrência",
      flex: 1,
      headerAlign: "center",
      renderCell: (params) => {
        let maior = rowsAloc[0]?.["Recorrência"];
        let percent = (params.value / maior) * 100;
        return (
          <Stack
            sx={{ height: "100%", width: "100%" }}
            alignItems="center"
            justifyContent="center"
            direction={"row"}
            gap={1}
          >
            <LinearProgress
              sx={styles.linearProgress}
              variant="determinate"
              value={percent}
            />
            <Typography sx={styles.textProgress}>{params.value}</Typography>
          </Stack>
        );
      },
    },
    ,
  ];

  const LoadingChart = () => (
    <>
      <Stack
        direction={"row"}
        ml={"20px"}
        width={"100%"}
        height={"100%"}
        gap={1}
      >
        <Stack
          direction={"column"}
          width={"3%"}
          justifyContent={"space-around"}
          alignItems={"end"}
        >
          <Skeleton
            variant="rounded"
            animation="wave"
            width={"95%"}
            height={10}
          />
          <Skeleton
            variant="rounded"
            animation="wave"
            width={"90%"}
            height={10}
          />
          <Skeleton
            variant="rounded"
            animation="wave"
            width={"100%"}
            height={10}
          />
          <Skeleton
            variant="rounded"
            animation="wave"
            width={"85%"}
            height={10}
          />
          <Skeleton
            variant="rounded"
            animation="wave"
            width={"100%"}
            height={10}
          />
          <Skeleton
            variant="rounded"
            animation="wave"
            width={"95%"}
            height={10}
          />
          <Skeleton
            variant="rounded"
            animation="wave"
            width={"100%"}
            height={10}
          />
          <Skeleton
            variant="rounded"
            animation="wave"
            width={"80%"}
            height={10}
          />
          <Skeleton
            variant="rounded"
            animation="wave"
            width={"100%"}
            height={10}
          />
        </Stack>
        <Stack direction={"column"} width={"93%"} gap={1}>
          <Skeleton variant="rounded" width="100%" height={"100%"} />

          <Stack direction={"row"} justifyContent={"space-around"}>
            <Skeleton
              variant="rounded"
              animation="wave"
              width={"10%"}
              height={10}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              width={"10%"}
              height={10}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              width={"10%"}
              height={10}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              width={"10%"}
              height={10}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              width={"10%"}
              height={10}
            />
          </Stack>
        </Stack>
      </Stack>
    </>
  );

  return (
    <>
      <Stack
        width={"100%"}
        sx={{ flexDirection: { xs: "column", md: "row" }, gap: 2 }}
      >
        <Paper
          sx={{
            ...styles.paper,
            width: { xs: "100%", md: "65%" },
          }}
        >
          <Typography sx={styles.titlePaper}>
            <Box sx={styles.bar} />
            Variação de Portas por Tempo
          </Typography>
          <Box sx={{ p: "5px", width: "100%", height: "100%" }}>
            {loadingVarPort ? (
              <LoadingChart />
            ) : (
              <ResponsiveArea
                theme={theme}
                data={portsTime.map((a) => ({
                  ...a,
                  portCount: parseInt(a.portCount),
                }))}
              />
            )}
          </Box>
        </Paper>
        <Paper
          sx={{
            ...styles.paper,
            width: { xs: "100%", md: "35%" },
          }}
        >
          <Typography sx={styles.titlePaper}>
            <Box sx={styles.bar} />
            Alocação de Portas por Cliente
          </Typography>
          <DataGrid
            apiRef={apiRefAloc}
            loading={loadingAloc}
            density="compact"
            sx={{ ...styles.dataGrid, "--DataGrid-overlayHeight": "300px" }}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            slotProps={{
              loadingOverlay: {
                variant: "skeleton",
                noRowsVariant: "skeleton",
              },
            }}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: -1,
                },
              },
            }}
            hideFooter={true}
            columnVisibilityModel={{ id: false }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
            rows={rowsAloc}
            columns={columns}
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
            disableRowSelectionOnClick
          />
        </Paper>
      </Stack>
    </>
  );
};
